module.exports = __webpack_public_path__ + "img/4.082c0a24.svg";